import { lstore, sstore, cookie } from '@/libs/utils/util';
import { gotoUrl } from './util';
import {
  Login,
  Logout,
  StaffLoginByOIDCForManager,
  StaffLoginWithWorkwxForManager,
  LoginPhoneBound,
} from '@/api/login';
const login = {
  storageType: '', // cookie sstore lstore 默认sstore
  setStorageType(val) {
    this.storageType = val;
    try {
      window.localStorage.setItem(this.loginKey('storage'), val);
    } catch (e) {}
  },
  getStorageType() {
    if (!this.storageType) {
      try {
        const storageType = window.localStorage.getItem(this.loginKey('storage'));
        if (storageType) this.storageType = storageType;
      } catch (e) {}
    }
    return this.storageType;
  },
  loginKey(name) {
    const key = {
      token: 'saas_token',
      uin: 'saas_uin',
      domain: null,
      storage: 'saas_storage',
    };
    return key[name];
  },
  setLogin({ token, uin, time }) {
    const timeMinute = time > 60 ? (time - 60) / 60 : 60;
    const timeSecond = time > 60 ? time - 60 : 60 * 60;
    const tokenKey = this.loginKey('token');
    const uinKey = this.loginKey('uin');
    const storageType = this.getStorageType();
    if (storageType === 'lstore') {
      token ? lstore.setItem(tokenKey, token, timeSecond) : lstore.removeItem(tokenKey);
      uin ? lstore.setItem(uinKey, uin, timeSecond) : lstore.removeItem(uinKey);
    } else if (storageType === 'cookie') {
      const domain = this.loginKey('domain');
      const path = '/';
      token
        ? cookie.setCookie(tokenKey, token, timeMinute, path, domain)
        : cookie.delCookie(tokenKey, path, domain);
      uin
        ? cookie.setCookie(uinKey, uin, timeMinute, path, domain)
        : cookie.delCookie(uinKey, path, domain);
    } else {
      token ? sstore.setItem(tokenKey, token, timeSecond) : sstore.removeItem(tokenKey);
      uin ? sstore.setItem(uinKey, uin, timeSecond) : sstore.removeItem(uinKey);
    }
  },
  getToken() {
    const storageType = this.getStorageType();
    const tokenKey = this.loginKey('token');
    let token = sstore.getItem(tokenKey);
    if (storageType === 'lstore') {
      token = lstore.getItem(tokenKey);
    } else if (storageType === 'cookie') {
      token = cookie.getCookie(tokenKey);
    }
    return token || '';
  },
  getUin() {
    const storageType = this.getStorageType();
    const tokenKey = this.loginKey('uin');
    let token = sstore.getItem(tokenKey);
    if (storageType === 'lstore') {
      token = lstore.getItem(tokenKey);
    } else if (storageType === 'cookie') {
      token = cookie.getCookie(tokenKey);
    }
    return token || '';
  },
  toLogin() {
    const whiteList = ['/saas/login.html', '/saas/login/door.html'];
    if (whiteList.includes(window.location.pathname)) {
      return;
    }
    if (window.location.pathname.includes('/japi/qiye/oauth/ticket')) {
      return;
    }
    gotoUrl(`/saas/login.html?redirect_uri=${encodeURIComponent(window.location.href)}`, {
      href: true,
    });
  },
  clearLogin() {
    login.setLogin({ token: '', uin: '' });
  },
  exit() {
    Logout({ token: this.getToken() })
      .then(() => {
        this.setLogin({ token: '', uin: '' });
        try {
          localStorage.removeItem('myEndTime');
        } catch (e) {}
        this.toLogin();
      })
      .catch((e) => {
        throw e;
      });
  },
  phoneLogin(phone, smscode) {
    return Login({ phone, password: smscode }).then((res) => {
      if (res.token) {
        this.setLogin({
          token: res.token,
          uin: res.uin,
          time: res.expires_in,
        });
      }
      return res;
    });
  },
  qrCodeLogin(code, agentId) {
    return StaffLoginWithWorkwxForManager({
      code,
      agent_id: agentId,
    }).then(({ token, uin, expires_in: time }) => {
      this.setLogin({ token, uin, time });
    });
  },
  oktaLogin(code, state, nonce) {
    return new Promise((resolve, reject) => {
      StaffLoginByOIDCForManager({
        code,
        state,
        nonce,
      })
        .then(({ token, uin, expires_in: time, phone, staff_status }) => {
          this.setLogin({ token, uin, time });
          resolve({ phone, status: staff_status });
        })
        .catch((e) => reject(e));
    });
  },
  oktaBindPhone(phone, code) {
    return LoginPhoneBound({
      phone,
      code,
    });
  },
};
export default login;
